import {RadioGroup, ReversedRadioButton} from "react-radio-buttons";
import React from "react";
import {FormattedMessage} from "react-intl";


const StepHouseOptions = {
 all : (onRadioChange, IsNieuwbouw) => {
    return (
      <RadioGroup
      onChange={onRadioChange}
      value={IsNieuwbouw}
      className="ct-step__radio-group ct-step__radio-group-vertical already-found-a-house"
      >
        <ReversedRadioButton
        value="0"
        rootColor="#000000"
        pointColor="#000000"
        iconInnerSize={18}
        iconSize={18}
        >
          <FormattedMessage id={"stepParts.stepHouseOptions.all.no"} defaultMessage={"Nee, nog niet"} />
        </ReversedRadioButton>

        <ReversedRadioButton
        value="1"
        rootColor="#000000"
        pointColor="#000000"
        iconInnerSize={18}
        iconSize={18}
        >
          <FormattedMessage id={"stepParts.stepHouseOptions.all.existing"} defaultMessage={"Ja, bestaande bouw"} />

        </ReversedRadioButton>

        <ReversedRadioButton
        value="2"
        rootColor="#000000"
        pointColor="#000000"
        iconInnerSize={18}
        iconSize={18}
        >

          <FormattedMessage id={"stepParts.stepHouseOptions.all.new"} defaultMessage={"Ja, nieuwbouw"} />

        </ReversedRadioButton>
      </RadioGroup>
    );
  },
  partial : (onRadioChange, IsNieuwbouw) => {
    return (
    <RadioGroup
    onChange={onRadioChange}
    value={IsNieuwbouw}
    className="ct-step__radio-group ct-step__radio-group-vertical already-found-a-house"
    >
      <ReversedRadioButton
      value="1"
      rootColor="#000000"
      pointColor="#000000"
      iconInnerSize={18}
      iconSize={18}
      >
        <FormattedMessage id={"stepParts.stepHouseOptions.partial.existing"} defaultMessage={"Bestaande bouw"} />
      </ReversedRadioButton>

      <ReversedRadioButton
      value="2"
      rootColor="#000000"
      pointColor="#000000"
      iconInnerSize={18}
      iconSize={18}
      >
        <FormattedMessage id={"stepParts.stepHouseOptions.partial.new"} defaultMessage={"Nieuwbouw"} />
      </ReversedRadioButton>
    </RadioGroup>
    );
  }
}


export default StepHouseOptions;
